import { Box } from '@mui/material';
import { TokenSupplyStatusDataGraph, TokenSupplyStatusDataName } from '../tokenSupplyStatus/MobileComponent';

export default function MobileTokenSupplyStatus({ type }: { type: string }) {
  return (
    <Box
      sx={{
        display: { xs: 'flex', md: 'none' },
        flexDirection: {
          xs: 'column',
          md: 'row',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          gap: '10px',
          position: 'relative',
          width: '100%',
        }}
      >
        <Box
          sx={{
            width: '3px',
            height: '100%',
            position: 'absolute',
            left: 0,
            top: 0,
            background: '#D9D9D9',
          }}
        ></Box>
        <TokenSupplyStatusDataName type={type} />
      </Box>

      <Box
        sx={{
          mt: '16px',
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
        }}
      >
        <TokenSupplyStatusDataGraph type={type} />
      </Box>
    </Box>
  );
}
